import React, { useEffect, useState } from "react";
import styles from "./meetingkeyword.module.scss";
import moment from "moment";
import { Dropdown, Form, Menu, Modal, Popover, Radio, Select, Tooltip } from "antd";
import { URAvatarGroup } from "../../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../../shared/widgets/avatarGroup/statusDot";
import store from "../../../../../context/store/store";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";
import { URInputwithLabel } from "../../../../../shared/widgets/inputwithLable";
import axios from "axios";
import { ccTabChange,setSearchKey } from "../../../../../base/meetingService/meetingStoreServices";
import { DataURIToBlob, getMOM, keyCopy, searchHandler, searchHighlight, toastInformation, updateCCToast, userStatusColor } from "../../../../../base/callService/common";
import jsPDF from 'jspdf';
import { isEmpty } from "lodash";
import _ from "lodash";
import Lottie from 'lottie-react';
import groovyWalkAnimation from "../../../../../styles/images/chat blank state loading.json";
import { useSelector } from "react-redux";
import { filesUploadApiSocket, generateChatID, userInfo } from "../../../../../base/socketChatService/utils";
import { LoginState } from "../../../../../models/model";
import { config } from "../../../../../base/constant";
import { getCookie } from "../../../../../base/utils";
import { SocketChatService } from "../../../../../base/socketChatService";
import { uuidv4 } from "../../../../../base/meetingService/utils/meetingServices";
import ReactQuill from "react-quill";
import ContactLoader from "../../../../../styles/images/Lottie Animation.json";
import { URInput } from "../../../../../shared/widgets/input";
const { Option } = Select;

type MeetingKeywordsState = {
  download: any;
  allContacts: any;
  favouriteContacts: any;
  shareUrl: string;
  shareContact: any;
  editModal: boolean;
};

export default function MeetingKeywords() {
  let { contactReducer }: any = useSelector((state: any) => state);

  let { workContacts, favContacts } = contactReducer;
  let { userdetails }: LoginState = store.getState().loginReducer;
  let { detailPage,keywords, momLoad, part_MOM } = store.getState().meetingReducer;
  const [getData, setData] = useState<MeetingKeywordsState>({
    download: "", allContacts: workContacts, favouriteContacts: favContacts, shareUrl: "", shareContact: [],
    editModal: false
  });

  const fontSize = ["10px", "15px", "18px", "20px", "32px", "54px"]
  const modules = {
    toolbar: {

      container: [
        ["bold", "italic", "underline", "strike"],
        [{ 'size': [fontSize] }],
        [
          { list: "ordered" },
          { list: "bullet" },
          { align: "right" }
        ],
        ["link", "image"]
      ]
    },
    clipboard: { matchVisual: false }
  };

  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "size",
    "list",
    "bullet",
    "link",
    "image",
    "align",
    "color",
    "background"
  ];


  const getKeyword=(data:any)=>{
    setSearchKey(data);
    ccTabChange("3");
    // searchTrancript(data, detailPage.uuid);
  }

  return (
    <>

      <div className={styles.tabsubinnerconsecmain}>
        <div className={styles.tabinnerbodyconsec}>
          <div className={styles.badgesecmore}>
            <ul>
           {keywords && keywords.map((elem:any,i:any)=>{
            return(<li key={i} onClick={()=>getKeyword(elem)}>{elem}</li>)
           })}
            </ul>
          </div>
          {
            (part_MOM?.length === 0) && !momLoad && <div className={styles.middlemainconsec}>
              <h4></h4>
              <p className={styles.nodatafound}>No Data Found</p>
            </div>
          }
          {
            part_MOM?.length === 0 && momLoad &&
            <div ><Lottie className="svgLoadinglistcenter" animationData={ContactLoader} /></div>
          }
        </div>
      </div>


    </>
  );
};

